// Community mesh resources and external links
import { trackExternalLink } from '../utils/analytics';

export function CommunityResources() {
  return (
    <section 
      id="community-resources" 
      className="relative z-10 mx-auto max-w-7xl px-6 py-16 pointer-events-none"
      style={{ scrollMarginTop: '100px' }}
    >
      <div className="pointer-events-auto">
        <h2 className="text-3xl font-bold mb-4 text-center">
          Community <span className="text-cyan-400">Mesh Resources</span>
        </h2>
        <p className="text-center text-zinc-400 mb-12 max-w-2xl mx-auto">
          Explore mesh networks around the world with these community-built tools and platforms.
        </p>

        {/* Featured Resource Card */}
        <div className="max-w-2xl mx-auto">
          <a
            href="https://mesh.axiom-labs.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
            onClick={() => trackExternalLink('mesh.axiom-labs.dev', 'community_resources')}
          >
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 transition-all duration-300 hover:border-cyan-400/50 hover:bg-zinc-900/70 hover:shadow-lg hover:shadow-cyan-400/10">
              <div className="flex items-start gap-6">
                {/* Icon/Logo */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-br from-cyan-400/20 to-cyan-600/20 rounded-xl border border-cyan-400/30 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg 
                      className="w-8 h-8 text-cyan-400" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" 
                      />
                    </svg>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-xl font-semibold text-white group-hover:text-cyan-400 transition-colors">
                      Axiom Labs Mesh Map
                    </h3>
                    <svg 
                      className="w-5 h-5 text-zinc-500 group-hover:text-cyan-400 group-hover:translate-x-1 transition-all" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                      />
                    </svg>
                  </div>
                  
                  <p className="text-zinc-400 mb-3 leading-relaxed">
                    Interactive local mesh network map showing Meshtastic nodes 
                    and real-time connectivity stats throughout the Clearwater/Largo/St.Pete/Tampa Bay area.
                  </p>

                  <div className="flex flex-wrap gap-2">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-cyan-400/10 text-cyan-400 border border-cyan-400/20">
                      🗺️ Interactive Map
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-cyan-400/10 text-cyan-400 border border-cyan-400/20">
                      🌍 Local Coverage
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-cyan-400/10 text-cyan-400 border border-cyan-400/20">
                      📡 Live Nodes
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* Future placeholder */}
        <div className="text-center mt-8">
          <p className="text-sm text-zinc-500">
            More community resources coming soon...
          </p>
        </div>
      </div>
    </section>
  );
}

